import { Phone, MessageCircle, Mail, MapPin, Clock, Send } from "lucide-react";
import { useState } from "react";
import { SHOP } from "../../storefront/StoreLayout";

export default function StoreContact() {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [msg, setMsg] = useState("");

  const sendWhatsApp = (e) => {
    e.preventDefault();
    const text = encodeURIComponent(`Namaste Trustmeds Pharma!\nNaam: ${name}\nPhone: ${phone}\nMessage: ${msg}`);
    window.open(`https://wa.me/917428811670?text=${text}`, "_blank");
  };

  const sendEmail = () => {
    if (!name || !phone || !msg) return;
    const subject = encodeURIComponent(`Website Inquiry — ${name} (${phone})`);
    const body = encodeURIComponent(`Naam: ${name}\nPhone: ${phone}\n\nMessage:\n${msg}`);
    window.location.href = `mailto:${SHOP.email}?subject=${subject}&body=${body}`;
  };

  const CARDS = [
    { icon: Phone, title: "Call karein", value: SHOP.phoneDisplay, href: `tel:+91${SHOP.phone}`, testid: "contact-call-card" },
    { icon: MessageCircle, title: "WhatsApp", value: "7428811670", href: SHOP.whatsapp, testid: "contact-whatsapp-card" },
    { icon: Mail, title: "Email", value: SHOP.email, href: `mailto:${SHOP.email}`, testid: "contact-email-card" },
    { icon: MapPin, title: "Directions", value: "Google Maps par dekhein", href: SHOP.mapsUrl, testid: "contact-map-card" },
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 py-10" data-testid="store-contact-page">
      <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900">Contact Us</h1>
      <p className="text-sm text-slate-500 mt-1 mb-8">Sawaal ho ya order — hum yahin hain, Kashipur mein.</p>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-8">
        {CARDS.map((c) => (
          <a key={c.title} href={c.href} target={c.href.startsWith("http") ? "_blank" : undefined} rel="noreferrer" data-testid={c.testid}
            className="bg-white border border-slate-200 rounded-2xl p-5 hover:border-emerald-300 hover:shadow-md transition-all block">
            <c.icon className="w-6 h-6 text-emerald-700 mb-3" />
            <div className="font-semibold text-slate-900 text-sm">{c.title}</div>
            <div className="text-xs text-slate-500 mt-1 break-all">{c.value}</div>
          </a>
        ))}
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        <div className="bg-white border border-slate-200 rounded-3xl p-6">
          <h2 className="font-display text-xl font-bold text-slate-900 mb-1">Store Address & Timing</h2>
          <div className="space-y-3 mt-4 text-sm text-slate-600">
            <div className="flex items-start gap-3"><MapPin className="w-4 h-4 text-emerald-700 shrink-0 mt-0.5" /> {SHOP.address}</div>
            <div className="flex items-center gap-3"><Clock className="w-4 h-4 text-emerald-700 shrink-0" /> {SHOP.hours}</div>
            <div className="flex items-center gap-3"><Phone className="w-4 h-4 text-emerald-700 shrink-0" /> {SHOP.phoneDisplay}</div>
          </div>
          <a href={SHOP.mapsUrl} target="_blank" rel="noreferrer" data-testid="contact-directions-btn"
            className="mt-5 inline-flex items-center gap-2 bg-[#064E3B] hover:bg-[#043B2C] text-white text-sm font-semibold px-5 py-3 rounded-full transition-colors">
            <MapPin className="w-4 h-4" /> Get Directions
          </a>
        </div>

        <form onSubmit={sendWhatsApp} className="bg-white border border-slate-200 rounded-3xl p-6">
          <h2 className="font-display text-xl font-bold text-slate-900 mb-1">Message bhejein</h2>
          <p className="text-xs text-slate-500 mb-4">Form bharne par aapka message seedha hamare WhatsApp par khulega.</p>
          <div className="space-y-3">
            <input required value={name} onChange={(e) => setName(e.target.value)} placeholder="Aapka naam *" data-testid="contact-name-input"
              className="w-full h-11 px-4 rounded-xl border border-slate-300 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-600" />
            <input required value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Phone number *" data-testid="contact-phone-input" inputMode="numeric"
              className="w-full h-11 px-4 rounded-xl border border-slate-300 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-600" />
            <textarea required value={msg} onChange={(e) => setMsg(e.target.value)} placeholder="Kya poochhna hai? *" rows={3} data-testid="contact-message-input"
              className="w-full px-4 py-3 rounded-xl border border-slate-300 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-600" />
            <button type="submit" data-testid="contact-send-btn"
              className="w-full inline-flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1EBE5D] text-white font-semibold py-3 rounded-full transition-colors">
              <Send className="w-4 h-4" /> WhatsApp par bhejein
            </button>
            <button type="button" onClick={sendEmail} data-testid="contact-email-send-btn"
              className="w-full inline-flex items-center justify-center gap-2 border-2 border-emerald-700 text-emerald-700 hover:bg-emerald-50 font-semibold py-3 rounded-full transition-colors">
              <Mail className="w-4 h-4" /> Email par bhejein
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
